const BASE_GAMES  = [
// {
// id: 'test-game',
// title: 'Test Webgl',
// description: 'Testing.',
// genre: 'RPG',
// image: 'kepithor_logo.png',
// googlePlayUrl: 'https://play.google.com/store/apps/details?id=com.KepithorStudios.Earnz',
// webglPath: '/webgl/test-game/index.html',
// isWeb3: true,
// platforms: ['web', 'pc'],
// tags: ['test', 'pvp'],
// source: 'not us',
// optionsDescription: {
// browser: 'Launch instantly in your browser. No downloads needed!',
// mobile: 'Play on the go and compete for Kepi on Android.',
// }
// },
{
id: 'earnz',
title: 'Earnz: Turn ads into rewards',
description: 'EarnZ lets you earn real rewards just by listening to short audio ads, answering surveys, or trying new games. It\’s simple, passive, and works while you go about your day.',
genre: 'Earn Money',
image: '/games/earnz.jpg',
googlePlayUrl: 'https://play.google.com/store/apps/details?id=com.KepithorStudios.Earnz',
webglPath: '',
isWeb3: true,
platforms: ['android'],
tags: ['Earn', 'Kepi', 'Giftcards'],
source: 'Kepithor',
optionsDescription: {
browser: 'Launch instantly in your browser. No downloads needed!',
mobile: 'Play on the go and compete for Kepi on Android.',
}
},
{
id: 'royal-rampage-mobile',
title: 'Royal Rampage: mobile',
description: 'Fast real-time PvP battles that last around 3 minutes. Collect cards & battle in PvP.',
genre: 'TCG',
image: '/games/royal-rampage.png',
googlePlayUrl: 'https://play.google.com/store/apps/details?id=com.KepithorStudios.RoyalRampage',
webglPath: '',
isWeb3: true,
platforms: [ 'android'],
tags: ['Kepi', 'Crypto', 'Play & Earn', 'PvP', 'TCG', 'RTS', 'BSC', 'Strategy'],
source: 'Kepithor',
optionsDescription: {
browser: 'Launch instantly in your browser. No downloads needed!',
mobile: 'Play on the go and compete for Kepi on Android.',
}
},
{
id: 'royal-rampage',
title: 'Royal Rampage: browser',
description: 'Fast real-time PvP battles that last around 3 minutes. Collect cards & battle in PvP.',
genre: 'TCG',
image: '/games/royal-rampage.png',
googlePlayUrl: 'https://play.google.com/store/apps/details?id=com.KepithorStudios.RoyalRampage',
webglPath: '/webgl/royal-rampage/index.html',
isWeb3: false,
platforms: ['web'],
tags: ['PvP', 'TCG', 'RTS', 'Strategy'],
source: 'Kepithor',
optionsDescription: {
browser: 'Launch instantly in your browser. No downloads needed!',
mobile: 'Play on the go and compete for Kepi on Android.',
}
},
{
id: 'karnage-clicker',
title: 'KK Clicker: Idle Miner',
description: 'Mine gems, hire workers for auto-mining, and boost your efficiency with upgrades. The gem race awaits — are you ready to lead?',
genre: 'Idle Miner',
image: '/games/karnage-clicker.png',
googlePlayUrl: 'https://play.google.com/store/apps/details?id=com.KepithorStudios.KingdomKarnageClicker',
webglPath: '',
isWeb3: true,
platforms: ['android'],
tags: ['Kepi', 'Crypto', 'BSC', 'Strategy', 'Play & Earn'],
source: 'Kepithor',
optionsDescription: {
browser: 'Launch instantly in your browser. No downloads needed!',
mobile: 'Play on the go and compete for Kepi on Android.',
}
},
{
id: 'kingdom-karnage',
title: 'Kingdom Karnage: PvP Card Game',
description: 'prepare for battle by selecting your top 25 cards, and dive into real-time PvP battles. Compete in PvP for weekly rewards and aim to be the top player.',
genre: 'TCG',
image: '/games/kingdom-karnage.png',
googlePlayUrl: 'https://play.google.com/store/apps/details?id=com.KepithorStudios.Karnage',
webglPath: '',
isWeb3: true,
platforms: ['android'],
tags: ['Kepi', 'Crypto', 'BSC', 'PvP', 'Strategy', 'Turn-Based', 'Play & Earn'],
source: 'Kepithor',
optionsDescription: {
browser: 'Launch instantly in your browser. No downloads needed!',
mobile: 'Play on the go and compete for Kepi on Android.',
}
},
{
id: 'enj-excavators',
title: 'Enj Excavators',
description: 'ENJ Excavators is a free-to-play hyper-casual mobile game where you mine Gems, upgrade your equipment to increase your efficiency, and compete to earn cryptocurrency rewards.',
genre: 'Idle Miner',
image: '/games/enj-ex.jpg',
googlePlayUrl: 'https://play.google.com/store/apps/details?id=com.KepithorStudios.EnjExcavators',
webglPath: '',
isWeb3: true,
platforms: ['android'],
tags: ['Crypto', 'Enj', 'Enjin', 'Strategy', 'NFT', 'Play & Earn'],
source: 'Kepithor',
optionsDescription: {
browser: 'Launch instantly in your browser. No downloads needed!',
mobile: 'Play on the go and compete for Kepi on Android.',
}
},
{
id: 'karnage-heroes',
title: 'KK Heroes: PvP Squad Battle',
description: 'Engage in swift, AI-controlled battles against other players\' decks. Masterfully manage a team of warriors, earn Ability Points in battle, and use them to enhance your team\'s stats.',
genre: 'Idle Battler',
image: '/games/heroes.png',
googlePlayUrl: 'https://play.google.com/store/apps/details?id=com.KepithorStudios.KingdomKarnageHeroes',
webglPath: '',
isWeb3: true,
platforms: ['android'],
tags: ['Crypto', 'Kepi', 'BSC', 'Strategy', 'PvP', 'Play & Earn'],
source: 'Kepithor',
optionsDescription: {
browser: 'Launch instantly in your browser. No downloads needed!',
mobile: 'Play on the go and compete for Kepi on Android.',
}
},
{
id: 'gbr',
title: 'Great British Raffle-Win Daily',
description: 'Your daily chance to win a gift card.',
genre: 'Raffle',
image: '/games/gbr.jpg',
googlePlayUrl: 'https://play.google.com/store/apps/details?id=com.KepithorStudios.GreatBritishRaffle',
webglPath: '',
isWeb3: true,
platforms: ['android'],
tags: ['Earn', 'Kepi', 'Giftcards', 'Crypto', 'BSC', 'Play & Earn'],
source: 'Kepithor',
optionsDescription: {
browser: 'Launch instantly in your browser. No downloads needed!',
mobile: 'Play on the go and compete for Kepi on Android.',
}
},
{
id: 'kepithor-rewards',
title: 'Kepithor Rewards',
description: 'Earn cryptocurrency simply by watching advertisements. It\'s a seamless and rewarding experience where you can earn while going about your day.',
genre: 'Crypto Miner',
image: '/games/kepithor-rewards.png',
googlePlayUrl: 'https://play.google.com/store/apps/details?id=com.KepithorStudios.KKTFaucet',
webglPath: '',
isWeb3: true,
platforms: ['android'],
tags: ['Kepi', 'Crypto', 'BSC'],
source: 'Kepithor',
optionsDescription: {
browser: 'Launch instantly in your browser. No downloads needed!',
mobile: 'Play on the go and compete for Kepi on Android.',
}
},
// {
// id: 'into-the-multiverse',
// title: 'Into the Multiverse',
// description: 'The Web3 Endless Runner with advanced controls, abilities, and parkour.',
// genre: 'Endless Runner',
// image: 'https://cdn.prod.website-files.com/60f93c8e038fc32afa829f7d/685df9dfcb588286ee1d1fbe_66cdfa90d16414f90fd73b2c_Splash.webp',
// googlePlayUrl: '',
// webglPath: 'https://www.play2earn.club/play.html',
// isWeb3: true,
// platforms: ['web'],
// tags: ['Enj', 'Crypto', 'NFT'],
// source: 'CZB Labs',
// optionsDescription: {
// browser: 'Launch instantly in your browser. No downloads needed!',
// mobile: '',
// }
// },





];
export default BASE_GAMES ;